import { createContext } from "react";

export var UserContext = createContext(null)
export var RolesContext = createContext(null)
export var CSRFContext = createContext(null)
export var alertsContext = createContext([])